import { Palette, PaletteColor } from "@mui/material";
import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";
import { makeStyles } from "tss-react/mui";

interface IParams {
    color: keyof Palette;
}

export const useStyle = makeStyles<IParams>()((theme, props) => {
    const paletteColor = theme.palette[props.color] as PaletteColor;

    return {
        banner: {
            backgroundColor: paletteColor.main,
            height: 76,
            transition: "height 0.3s ease",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            position: "sticky",
            [getThemeBreakpointByDeviceType(theme, EDeviceType.TABLET_OR_DESKTOP)]: {
                top: 0,
            },
            [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
                bottom: 0,
            },
        },
        bannerWrapper: {
            alignItems: "center",
            maxWidth: 1280,
            paddingInline: theme.spacing(5),
            width: "100%",
        },
        bannerButton: {
            backgroundColor: theme.palette.quaternary.main,
            color: theme.palette.quaternary.contrastText,
            padding: theme.spacing(2, 3),
            fontWeight: theme.typography.fontWeightLight,
            textTransform: "none",
            height: "44px",
            "&:hover": {
                backgroundColor: theme.palette.quaternary.main,
            },
            "&:focus-visible": {
                outline: `2px solid ${theme.palette.secondary.main}!important`,
                outlineOffset: "2px",
            },
        },
        loaderWrapper: {
            color: paletteColor.contrastText,
        },
        title: {
            fontWeight: 450,
            fontSize: 20,
            [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE_OR_TABLET)]: {
                fontSize: 16,
            },
        },
    };
});
